import React, { useContext, useEffect, useState } from "react";
import "./Overview.scss";
import testimage from './testimage.png'
import DropDown from "../../_default/DropDown";
import FormQuestion from "../Form/FormQuestion";
import { getCLientFormResponse, getClients } from "../../../services/firebase/firestore/getData";
import SidebarInfo from "../SidebarInfo";
import Male from "./male.png"
import Female from "./female.png"
import Cake from "./cake.png"
import Placeholder from "./placeholder.jpg"
import Inviter from "../Inviter";
import SearchPage from "../../_default/SearchPage";
import Icon from "../../_default/Icon";
import { Button, Modal } from "semantic-ui-react";
import Popup from "../../_default/Popup";
import { deleteClient } from "../../../services/firebase/firestore/deleteData";
import SelectSearch from "react-select-search";
import 'react-select-search/style.css'
import UserContext from "../../../services/context/userContext";
import Select from 'react-select';
export default function Overview({ props, selected_client, clientList, selectClient }) {
	var [filter, setFilter] = useState("All");
	const filters = ["All", "Coach", "Goals", "Lifestyle", "Medical", "Nutrition", "Feedback form"];
	var [filter2, setFilter2] = useState(false);
	const filters2 = ["Coach", "Goals", "Lifestyle", "Medical", "Nutrition"];
	const [clientResponse, setClientResponse] = useState(false);

	const [filterName, setFilterName] = useState(false);
	const [client_name, setCLientName] = useState(false);
	const [clients, setClients] = useState(false);
	const [initial, setInitial] = useState(false);
	let [searchClient, setSearchClient] = useState("")
	let [client, setClient] = useState(false)
	let [options, setGetClient] = useState([])
	let user = useContext(UserContext)
	const classes = {
		container: {
			width: "90%"
		}
	}
	// const options = [
	// 	{ value: 'chocolate', label: 'Chocolate' },
	// 	{ value: 'strawberry', label: 'Strawberry' },
	// 	{ value: 'vanilla', label: 'Vanilla' },
	// ];
	useEffect(() => {
		getClients(user.id, res => {
			setGetClient(res)
			console.log("get clients", res)
		})
	}, [])
	useEffect(() => {
		// debugger
		getCLientFormResponse(selected_client.id, (result) => {
			setClientResponse(result);
		});
	}, [selected_client.id]);


	useEffect(() => {
		let clientNames = [];
		let clients = [];
		clientList && clientList.forEach(element => {
			clientNames.push(element.first_name + " " + element.last_name);
			clients.push({
				name: element.first_name + " " + element.last_name,
				id: element.id
			})
		});
		setFilter2(selected_client.first_name + ' ' + selected_client.last_name);
		setClients(clients);
		setFilterName(clientNames);


		clientResponse?.length > 0 && clientResponse.map((item) => {
			const all_forms = { filter: 'All', form: [] }
			if (filter === "All") {
				item.form.map(doc => {
					all_forms.form.push(doc);
				})
				setInitial(all_forms);
			}
		})
	}, [clientResponse]);

	const gotoClient = (data) => {
		setClient(true)
		console.log("valuee", data)
		// debugger
		console.log("go to clien", data, clients.filter((client) => client.name[0] == "H"))
		let selectedclient = clients.filter(client => client.id == data);
		console.log("selected client", selectedclient)
		window.location.href = '/clients/' + selectedclient[0].id;



	}
	// useEffect(()=>{
	// 	gotoClient()
	// },[searchClient])
	let [deleteModal, setDeleteModal] = useState(false)
	let removeClient = (id) => {
		// debugger
		console.log("clientssss", clients)
		setDeleteModal(false)
		console.log("del id", selected_client.id)

		deleteClient(selected_client.id, res => {
			console.log("dele res", res)
			if (clients[clients.length - 1].id === selected_client.id) {
				window.location.href = "/clients/" + clients[clients.length - 2].id
			} else {
				window.location.href = "/clients/" + clients[clients.length - 1].id
			}
		})
	}
	let handleSearchClient = (e) => {
		console.log("search clien", e, clients)
	}
	return (
		<>
			{

				console.log("selecteddd", selected_client)
			}
			<div className="custom-search-div" style={{
				// width: "73%",
				borderRadius: "39px",
				marginTop: "36px"
			}} >
				{/* <SearchPage placeholder="Search Client" value={searchClient} onChange={(e) => { setSearchClient(e.target.value); gotoClient(e.target.value) }} /> */}
				{/* <input   name="search" value={searchClient} onChange={(e) => { setSearchClient(e.target.value); gotoClient(e.target.value) }} /> */}
				{/* <SelectSearch options={options} value="sv" name="language" placeholder="Choose your language" /> */}
				{/* <Select
					options={
						options.map((data) => ({

							value: data.userID,
							label: data.first_name + " " + data.last_name,

						}))}
					onChange={(e) => { setSearchClient(e.label); gotoClient(e.value) }}
					// search
					placeholder="Search Client"
				/> */}


			</div>
			{
				selected_client &&

				<div className="c-client-container">

					<div style={{ float: "right", position: "relative", zIndex: "2", cursor: "pointer" }}>
						<button style={{ cursor: "pointer" }} onClick={() => setDeleteModal(true)} >
							<Icon icon="trash" size={20} height={20} />

						</button>
					</div>
					<div className="c-content">

						<div className="c-profile-img" style={{ backgroundImage: `url('${selected_client?.image ? selected_client.image : Placeholder}')` }}></div>
						<div className="c-profile-content">
							<h1>{selected_client.first_name} {selected_client.last_name}</h1>
							<div className="c-content c-profile-info">
								<div className="c-content">
									<img src={selected_client?.gender === "Male" ? Male : Female} />
									<p>{selected_client?.gender ? selected_client.gender : ""}</p>
								</div>
								<div className="c-content">
									<img src={Cake} />
									<div className="c-content-year-data">
										<p>{selected_client.date_of_birth}</p>
										<span>{selected_client.age ? selected_client.age + " years old" : ""}</span>
									</div>
								</div>
							</div>

							<SidebarInfo selected_client={selected_client}></SidebarInfo>
							<div className="dropdown-overview">
								{/* <DropDown options={filterName ? filterName : []} value={filter2} onChange={(e) => { setFilter2(e); gotoClient(e); }} /> */}
								{/* <Icon /> */}
							</div>

						</div>

					</div>

				</div>
			}
			{initial?.form?.length > 0 &&
				<div className="c-client-container" style={{ marginBottom: 40 }}>
					<h2 >Forms</h2>
					<div className="c-overview-form-dropdow">
						<DropDown options={filters} value={filter} onChange={(e) => setFilter(e)} />
					</div>
					<div>
						<FormQuestion form={clientResponse} initial={initial} filter={filter}></FormQuestion>
					</div>
				</div>
			}
			{
				deleteModal &&
				<Popup
					title={"Delete Client"}
					button="Delete"
					deletePopup={true}
					description={"Are you sure you want to delete this Client? This can not be undone."}
					onAction={removeClient}
					onCancel={() => {
						setDeleteModal(false);
					}}
				/>
			}
		</>
	);
}